import { putData, getData } from './FetchNodeServices.js';

export const updateSingleDocumentNumber = async (
  moduleKey: string,
  id: string,
  newNumber: string
): Promise<{ success: boolean; message: string; data?: any }> => {
  const res = await putData('api/v1/invoice-settings/update-single-doc-number', {
    moduleKey,
    id,
    newNumber,
  });
  if (res && res.success) {
    return res;
  }
  throw new Error(res?.message || 'Failed to update document number');
};

export const getNextDocumentNumber = async (
  docType: string,
  warehouseId?: string
): Promise<{ success: boolean; data: { nextNumber: string; prefix: string; sequence: number } }> => {
  const params = new URLSearchParams({ docType });
  if (warehouseId) params.append('warehouseId', warehouseId);
  const res = await getData(`api/v1/invoice-settings/next-doc-number?${params.toString()}`);
  if (res && res.success) {
    return res;
  }
  throw new Error(res?.message || 'Failed to fetch next document number');
};
